module.exports = __webpack_public_path__ + "static/media/diners-white.9f7de459.svg";